<template>
    <div class="card" :class="active" style="margin-bottom: 16px;">
        <div class="info">
                <div class="taskInfo">{{ item.title }}</div>
                <div class="userInfo">
                    <div>
                        {{item.User.email}}
                    </div>
                    <div>
                        {{item.createdAt.split('T')[0]}}
                    </div>
                </div>
                <div class="control">
                    <button class="fa fa-chevron-circle-left btn-primary float-left" @click="prevTask(item.category,item.id)"></button>
                    <button class="fa fa-chevron-circle-right btn-primary float-left" @click="nextTask(item.category,item.id)"></button>
                    <button class="fa fa-trash btn-danger float-right" @click="deleteTask(item.id)"></button>
                </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
    name: "Card",
    data() {
        return {
            url: 'https://gentle-gorge-36916.herokuapp.com',
            active: "non"
        }
    },
    props: {
        item: Object
    },
    methods: {
        deleteTask(id) {
            swal({
                title: 'Do you want delete this task?',
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })
            .then(confirm=>{
                if(confirm){
                    return axios({
                    url: `${this.url}/tasks/${id}`,
                    method: 'delete',
                    headers: {
                        token: localStorage.token
                    }
                    })
                }
            })
            .then(data=>{
                if (!data) {
                    swal('Done!','Cancel delete task','info')
                } else {
                    swal('Done!','Your task has been deleted','success')
                        this.$emit('reloadTask')
                    }
                })
            .catch(err=>{
                swal("Error!",err.response.data.message,"error")
            })
        },
        prevTask(old,id) {
            let prev = ''

            switch(old) {
                case 'Backlog':
                    prev = 'Backlog'
                    break
                case 'Todo':
                    prev = 'Backlog'
                    break
                case 'Done':
                    prev = 'Todo'
                    break
                case  'Complete':
                    prev = 'Done'
                    break
            }

            axios({
                url : `${this.url}/tasks/${id}`,
                method: 'put',
                headers: {
                    token: localStorage.token
                },
                data: {
                    category: prev
                }
            })
            .then(response => {
                this.$emit('reloadTask')
            })
            .catch(err => {
                swal("Error!",err.response.data.message,"error")
            })
        },
        nextTask(oldCat,id) {
            let newCat = ''

            switch(oldCat) {
                case 'Backlog':
                    newCat= 'Todo'
                    break
                case 'Todo':
                    newCat = 'Done'
                    break
                case 'Done':
                    newCat = 'Complete'
                    break
                case  'Complete':
                    newCat = 'Complete'
                    break
            }

            axios({
                url : `${this.url}/tasks/${id}`,
                method: 'put',
                headers: {
                    token: localStorage.token
                },
                data: {
                    category: newCat
                }
            })
            .then(response => {
                this.$emit('reloadTask')
            })
            .catch(err => {
                swal("Error!",err.response.data.message,"error")
            })
        },
        checkActive() {
            if (this.item.User.id == localStorage.getItem('idUser')) {
                this.active = "active"
                this.$emit('reloadTask')
            }
        }
    },
    created() {
        this.checkActive()
    }
}
</script>